import { render, staticRenderFns } from "./ParamsConfig.vue?vue&type=template&id=803829ba&scoped=true"
import script from "./ParamsConfig.vue?vue&type=script&lang=js"
export * from "./ParamsConfig.vue?vue&type=script&lang=js"
import style0 from "./ParamsConfig.vue?vue&type=style&index=0&id=803829ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803829ba",
  null
  
)

export default component.exports